import { jsx as l, jsxs as H } from "react/jsx-runtime";
import { forwardRef as q, Fragment as j } from "react";
function Y(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var T = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var A;
function U() {
  return A || (A = 1, function(r) {
    (function() {
      var u = {}.hasOwnProperty;
      function p() {
        for (var e = "", n = 0; n < arguments.length; n++) {
          var i = arguments[n];
          i && (e = t(e, a(i)));
        }
        return e;
      }
      function a(e) {
        if (typeof e == "string" || typeof e == "number")
          return e;
        if (typeof e != "object")
          return "";
        if (Array.isArray(e))
          return p.apply(null, e);
        if (e.toString !== Object.prototype.toString && !e.toString.toString().includes("[native code]"))
          return e.toString();
        var n = "";
        for (var i in e)
          u.call(e, i) && e[i] && (n = t(n, i));
        return n;
      }
      function t(e, n) {
        return n ? e ? e + " " + n : e + n : e;
      }
      r.exports ? (p.default = p, r.exports = p) : window.classNames = p;
    })();
  }(T)), T.exports;
}
var K = U();
const V = /* @__PURE__ */ Y(K), f = {
  "purpur-heading": "_purpur-heading_k9fhq_1",
  "purpur-heading--hyphens": "_purpur-heading--hyphens_k9fhq_8",
  "purpur-heading--negative": "_purpur-heading--negative_k9fhq_11",
  "purpur-heading--subsection-100": "_purpur-heading--subsection-100_k9fhq_14",
  "purpur-heading--title-100": "_purpur-heading--title-100_k9fhq_20",
  "purpur-heading--title-200": "_purpur-heading--title-200_k9fhq_26",
  "purpur-heading--title-300": "_purpur-heading--title-300_k9fhq_32",
  "purpur-heading--title-400": "_purpur-heading--title-400_k9fhq_38",
  "purpur-heading--title-500": "_purpur-heading--title-500_k9fhq_44",
  "purpur-heading--title-600": "_purpur-heading--title-600_k9fhq_50",
  "purpur-heading--title-700": "_purpur-heading--title-700_k9fhq_56",
  "purpur-heading--display-25": "_purpur-heading--display-25_k9fhq_62",
  "purpur-heading--display-50": "_purpur-heading--display-50_k9fhq_68",
  "purpur-heading--display-100": "_purpur-heading--display-100_k9fhq_74",
  "purpur-heading--display-200": "_purpur-heading--display-200_k9fhq_80"
}, G = {
  TITLE100: "title-100"
}, E = "purpur-heading", _ = ({
  children: r,
  className: u = "",
  enableHyphenation: p = !1,
  negative: a = !1,
  tag: t,
  variant: e = G.TITLE100,
  ...n
}) => {
  const i = t, o = V([
    u,
    f[E],
    f[`${E}--${e}`],
    {
      [f[`${E}--hyphens`]]: p,
      [f[`${E}--negative`]]: a
    }
  ]);
  return /* @__PURE__ */ l(i, { className: o, ...n, children: r });
};
_.displayName = "Heading";
function z(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var R = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var L;
function W() {
  return L || (L = 1, function(r) {
    (function() {
      var u = {}.hasOwnProperty;
      function p() {
        for (var e = "", n = 0; n < arguments.length; n++) {
          var i = arguments[n];
          i && (e = t(e, a.call(this, i)));
        }
        return e;
      }
      function a(e) {
        if (typeof e == "string" || typeof e == "number")
          return this && this[e] || e;
        if (typeof e != "object")
          return "";
        if (Array.isArray(e))
          return p.apply(this, e);
        if (e.toString !== Object.prototype.toString && !e.toString.toString().includes("[native code]"))
          return e.toString();
        var n = "";
        for (var i in e)
          u.call(e, i) && e[i] && (n = t(n, this && this[i] || i));
        return n;
      }
      function t(e, n) {
        return n ? e ? e + " " + n : e + n : e;
      }
      r.exports ? (p.default = p, r.exports = p) : window.classNames = p;
    })();
  }(R)), R.exports;
}
var X = W();
const J = /* @__PURE__ */ z(X), Q = {
  "purpur-link": "_purpur-link_1066f_1",
  "purpur-link--text": "_purpur-link--text_1066f_18",
  "purpur-link--standalone": "_purpur-link--standalone_1066f_18",
  "purpur-link--navigation": "_purpur-link--navigation_1066f_18",
  "purpur-link--disable-visited": "_purpur-link--disable-visited_1066f_29",
  "purpur-link--text-negative": "_purpur-link--text-negative_1066f_32",
  "purpur-link--standalone-negative": "_purpur-link--standalone-negative_1066f_32",
  "purpur-link--navigation-negative": "_purpur-link--navigation-negative_1066f_32",
  "purpur-link--ensure-target-area": "_purpur-link--ensure-target-area_1066f_71",
  "purpur-link--silent": "_purpur-link--silent_1066f_77"
}, F = J.bind(Q), c = "purpur-link", v = ({
  ["data-testid"]: r,
  children: u,
  className: p,
  disableVisited: a = !0,
  ensureTargetArea: t,
  href: e,
  negative: n = !1,
  onClick: i,
  rel: o,
  silent: h,
  target: M,
  variant: m,
  ...b
}) => (
  /* eslint-disable-next-line jsx-a11y/click-events-have-key-events */
  /* @__PURE__ */ l(
    "span",
    {
      className: F([
        p,
        c,
        `${c}--${n ? `${m}-negative` : m}`,
        {
          [`${c}--silent`]: h,
          [`${c}--negative`]: n,
          [`${c}--disable-visited`]: a ?? h,
          [`${c}--ensure-target-area`]: t
        }
      ]),
      "data-testid": r,
      onClick: e ? void 0 : i,
      ...b,
      children: e ? /* @__PURE__ */ l(
        "a",
        {
          href: e,
          target: M,
          rel: o,
          onClick: i,
          "data-testid": r ? `${r} a` : void 0,
          ...b,
          children: u
        }
      ) : u
    }
  )
);
v.displayName = "Link";
function Z(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var k = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var x;
function rr() {
  return x || (x = 1, function(r) {
    (function() {
      var u = {}.hasOwnProperty;
      function p() {
        for (var e = "", n = 0; n < arguments.length; n++) {
          var i = arguments[n];
          i && (e = t(e, a(i)));
        }
        return e;
      }
      function a(e) {
        if (typeof e == "string" || typeof e == "number")
          return e;
        if (typeof e != "object")
          return "";
        if (Array.isArray(e))
          return p.apply(null, e);
        if (e.toString !== Object.prototype.toString && !e.toString.toString().includes("[native code]"))
          return e.toString();
        var n = "";
        for (var i in e)
          u.call(e, i) && e[i] && (n = t(n, i));
        return n;
      }
      function t(e, n) {
        return n ? e ? e + " " + n : e + n : e;
      }
      r.exports ? (p.default = p, r.exports = p) : window.classNames = p;
    })();
  }(k)), k.exports;
}
var er = rr();
const tr = /* @__PURE__ */ Z(er), g = {
  "purpur-paragraph": "_purpur-paragraph_1rh57_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1rh57_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1rh57_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1rh57_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1rh57_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1rh57_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1rh57_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1rh57_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1rh57_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1rh57_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1rh57_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1rh57_60",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1rh57_67",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1rh57_75"
}, ar = {
  PARAGRAPH100: "paragraph-100"
}, d = "purpur-paragraph", $ = ({
  ["data-testid"]: r,
  children: u,
  className: p,
  disabled: a,
  enableHyphenation: t = !1,
  negative: e = !1,
  variant: n = ar.PARAGRAPH100,
  ...i
}) => {
  const o = tr([
    p,
    g[d],
    g[`${d}--${n}`],
    {
      [g[`${d}--hyphens`]]: t,
      [g[`${d}--disabled`]]: a,
      [g[`${d}--negative`]]: e
    }
  ]);
  return /* @__PURE__ */ l("p", { ...i, className: o, "data-testid": r, children: u });
};
$.displayName = "Paragraph";
function nr(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var D = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var N;
function pr() {
  return N || (N = 1, function(r) {
    (function() {
      var u = {}.hasOwnProperty;
      function p() {
        for (var e = "", n = 0; n < arguments.length; n++) {
          var i = arguments[n];
          i && (e = t(e, a(i)));
        }
        return e;
      }
      function a(e) {
        if (typeof e == "string" || typeof e == "number")
          return e;
        if (typeof e != "object")
          return "";
        if (Array.isArray(e))
          return p.apply(null, e);
        if (e.toString !== Object.prototype.toString && !e.toString.toString().includes("[native code]"))
          return e.toString();
        var n = "";
        for (var i in e)
          u.call(e, i) && e[i] && (n = t(n, i));
        return n;
      }
      function t(e, n) {
        return n ? e ? e + " " + n : e + n : e;
      }
      r.exports ? (p.default = p, r.exports = p) : window.classNames = p;
    })();
  }(D)), D.exports;
}
var ir = pr();
const ur = /* @__PURE__ */ nr(ir), lr = {
  "purpur-text-spacing": "_purpur-text-spacing_1qqyy_1"
}, sr = "purpur-text-spacing", or = ({ children: r, className: u, ...p }, a) => /* @__PURE__ */ l("div", { ref: a, className: ur(u, lr[sr]), ...p, children: r }), P = q(or);
P.displayName = "TextSpacing";
const hr = {
  HYPERLINK: "hyperlink",
  ENTRY_HYPERLINK: "entry-hyperlink",
  ASSET_HYPERLINK: "asset-hyperlink",
  RESOURCE_HYPERLINK: "resource-hyperlink",
  EMBEDDED_ENTRY: "embedded-entry-inline"
}, s = {
  DOCUMENT: "document",
  PARAGRAPH: "paragraph",
  TEXT: "text",
  HYPERLINK: "hyperlink",
  HEADER_1: "header-1",
  HEADER_2: "header-2",
  HEADER_3: "header-3",
  HEADER_4: "header-4",
  HEADER_5: "header-5",
  HEADER_6: "header-6",
  TABLE: "table",
  TABLE_ROW: "table-row",
  TABLE_HEADER_CELL: "table-header-cell",
  TABLE_CELL: "table-cell",
  TABLE_BODY: "table-body",
  OL_LIST: "ordered-list",
  UL_LIST: "unordered-list",
  LIST_ITEM: "list-item",
  HR: "horizontal-row",
  QUOTE: "blockquote",
  EMBEDDED_ENTRY: "embedded-entity",
  EMBEDDED_ASSET: "embedded-asset-block",
  IMAGE: "image",
  VIDEO: "video",
  RICHTEXTDOCUMENT: "rich-text-document",
  TEASER: "teaser"
}, y = {
  BOLD: "bold",
  ITALIC: "italic",
  UNDERLINE: "underline",
  CODE: "code"
}, cr = (r) => {
  var u;
  return r.type === s.TABLE_ROW && !!((u = r.content) != null && u.every((p) => p.type === s.TABLE_HEADER_CELL));
}, _r = (r, u) => {
  if (r.type !== s.TABLE)
    return u;
  const { content: p } = r, [a, t] = (p || []).reduce(
    ([i, o], h) => cr(h) ? [[...i, h], o] : [i, [...o, h]],
    [[], []]
  ), e = u.slice(0, a.length), n = u.slice(a.length, u.length);
  return /* @__PURE__ */ l("div", { className: "purpur-rich-text-table-scroll-container", children: /* @__PURE__ */ l("div", { className: "purpur-rich-text-table-inner-scroll-container", children: /* @__PURE__ */ H("table", { children: [
    a.length > 0 && /* @__PURE__ */ l("thead", { children: e }),
    t.length > 0 && /* @__PURE__ */ l("tbody", { children: n })
  ] }) }) });
}, B = (r, u) => Object.values(r).includes(u), C = (r) => (r == null ? void 0 : r.type) === "text", O = (r) => !w(r) && !C(r) && B(s, r == null ? void 0 : r.type), w = (r) => B(hr, r == null ? void 0 : r.type), gr = (r) => {
  try {
    return JSON.parse(r);
  } catch {
    return null;
  }
}, dr = (r, u = " ") => {
  const p = gr(r);
  return !p || !p.content ? "" : p.content.reduce((a, t, e) => {
    var h;
    let n = "";
    if (C(t))
      n = t.value;
    else if ((O(t) || w(t)) && (n = dr(JSON.stringify(t), u), !n.length))
      return a;
    const i = (h = p == null ? void 0 : p.content) == null ? void 0 : h[e + 1], o = O(i) ? u : "";
    return a + n + o;
  }, "");
};
function fr(r) {
  var u, p, a;
  return r.type === s.IMAGE && typeof r.value == "object" && (r != null && r.value) && "image" in r.value && ((p = (u = r == null ? void 0 : r.value) == null ? void 0 : u.image) != null && p.url) ? { ...r, value: { ...r.value, url: r.value.image.url } } : r.type === s.VIDEO && typeof r.value == "object" && (r != null && r.value) && "video" in r.value && ((a = r.value.video) != null && a.url) ? { ...r, value: { ...r.value, url: r.value.video.url } } : r;
}
const Er = {
  [y.BOLD]: (r) => /* @__PURE__ */ l("b", { children: r }),
  [y.ITALIC]: (r) => /* @__PURE__ */ l("i", { children: r }),
  [y.UNDERLINE]: (r) => /* @__PURE__ */ l("u", { children: r }),
  [y.CODE]: (r) => /* @__PURE__ */ l("code", { children: r })
};
function yr(r, u, p) {
  return {
    [s.RICHTEXTDOCUMENT]: (a, t) => t,
    [s.DOCUMENT]: (a, t) => t,
    [s.PARAGRAPH]: (a, t) => /* @__PURE__ */ l($, { variant: "paragraph-200", children: t }),
    [s.TEXT]: (a) => {
      const { value: t, marks: e } = a, n = typeof t == "string" ? t.replace(/\n/g, "<br />") : t, i = /* @__PURE__ */ l("span", { dangerouslySetInnerHTML: { __html: n } });
      return e ? e.reduce((o, h) => Er[h](o), i) : i;
    },
    [s.HYPERLINK]: ({ uri: a }, t) => r ? /* @__PURE__ */ l(v, { variant: "text", children: r(t, a) }) : /* @__PURE__ */ l(v, { variant: "text", children: /* @__PURE__ */ l("a", { href: a, children: t }) }),
    [s.HR]: () => /* @__PURE__ */ l("hr", {}),
    [s.HEADER_2]: (a, t) => /* @__PURE__ */ l(_, { tag: "h2", variant: "title-300", children: t }),
    [s.HEADER_3]: (a, t) => /* @__PURE__ */ l(_, { tag: "h3", variant: "title-200", children: t }),
    [s.HEADER_4]: (a, t) => /* @__PURE__ */ l(_, { tag: "h4", variant: "title-100", children: t }),
    [s.HEADER_5]: (a, t) => /* @__PURE__ */ l(_, { tag: "h5", variant: "title-100", children: t }),
    [s.HEADER_6]: (a, t) => /* @__PURE__ */ l(_, { tag: "h6", variant: "title-100", children: t }),
    [s.TABLE]: _r,
    [s.TABLE_ROW]: (a, t) => /* @__PURE__ */ l("tr", { children: t }),
    [s.TABLE_HEADER_CELL]: (a, t) => /* @__PURE__ */ l("th", { scope: "col", children: t }),
    [s.TABLE_CELL]: (a, t) => /* @__PURE__ */ l("td", { children: t }),
    [s.TABLE_BODY]: (a, t) => /* @__PURE__ */ l("tbody", { children: t }),
    [s.LIST_ITEM]: (a, t) => /* @__PURE__ */ l("li", { children: t }),
    [s.OL_LIST]: (a, t) => /* @__PURE__ */ l("ol", { children: t }),
    [s.UL_LIST]: (a, t) => /* @__PURE__ */ l("ul", { children: t }),
    [s.QUOTE]: (a, t) => /* @__PURE__ */ H("blockquote", { children: [
      "“",
      t,
      "”"
    ] }),
    [s.EMBEDDED_ENTRY]: (a, t) => t,
    [s.EMBEDDED_ASSET]: (a, t) => t,
    [s.IMAGE]: ({ value: a }) => {
      var t;
      return typeof a == "object" && a && "url" in a && a.url ? u ? u(a.url, a.altText, (t = a.image) == null ? void 0 : t.contentType) : /* @__PURE__ */ l("img", { src: a.url, alt: a.altText ?? "", loading: "lazy" }) : null;
    },
    [s.VIDEO]: ({ value: a }) => {
      var t;
      if (typeof a == "object" && a && "posterImage" in a) {
        const e = (t = a.posterImage) == null ? void 0 : t.url;
        return (
          // eslint-disable-next-line jsx-a11y/media-has-caption
          /* @__PURE__ */ l(
            "video",
            {
              "data-testid": "rich text video",
              controls: !0,
              src: a.url,
              poster: p && e ? p(e) : e
            }
          )
        );
      }
      return null;
    }
  };
}
const S = (r) => !r.replace(/\s+/g, ""), vr = (r) => {
  const { content: u, value: p } = r;
  if (!u)
    return typeof p == "string" && S(p);
  for (const a of u)
    if (a.type === s.HYPERLINK)
      return !1;
  return u.length > 0 && typeof u[0].value == "string" && S(u[0].value);
}, I = (r, u, p, a, t) => {
  let e = 0;
  const n = {
    ...yr(p, a, t),
    ...u
  }, i = (o) => {
    if (typeof n[o.type] > "u" || vr(o))
      return null;
    const h = o.content ? o.content.map(i) : [];
    return /* @__PURE__ */ l(j, { children: n[o.type](fr(o), h) }, e++);
  };
  return i(r);
};
function Tr({
  data: r,
  className: u,
  customNodeTypes: p,
  noTextSpacing: a = !1,
  link: t,
  image: e,
  videoPoster: n,
  ...i
}) {
  return r ? a ? /* @__PURE__ */ l("div", { className: u, ...i, children: I(r, p, t, e, n) }) : /* @__PURE__ */ l(P, { className: u, ...i, children: I(r, p, t, e, n) }) : null;
}
export {
  Tr as RichText,
  dr as richToPlainText
};
//# sourceMappingURL=rich-text.es.js.map
